<template>
	<ul
		role="menu"
		data-test="overview-export-menu"
		class="fixed z-50 py-1 m-0 list-none border rounded-md shadow-lg bg-neutral-800 border-neutral-700"
		:style="{ top: `${top}px`, left: `${left}px` }"
		@contextmenu.stop.prevent
	>
		<li role="none">
			<button
				ref="item"
				type="button"
				role="menuitem"
				data-test="export-image-item"
				class="flex items-center w-full gap-2 px-3 py-2 text-sm text-left text-white hover:bg-neutral-700 focus-visible:bg-neutral-700 focus:outline-none"
				@click="$emit('export')"
			>
				<IconShare size="14" />
				{{ label }}
			</button>
		</li>
	</ul>
</template>

<script>
import { IconShare } from '~/components/Icons'

// Estimated menu box for viewport clamping; exact size is not rendered yet.
const MENU_WIDTH = 220
const MENU_HEIGHT = 48
const VIEWPORT_MARGIN = 8

export default {
	name: 'OverviewExportMenu',
	components: {
		IconShare
	},
	props: {
		x: {
			type: Number,
			required: true
		},
		y: {
			type: Number,
			required: true
		}
	},
	computed: {
		label() {
			return this.$t('personality_results.overview.export_image')
		},
		left() {
			return this.clamp(this.x, window.innerWidth - MENU_WIDTH)
		},
		top() {
			return this.clamp(this.y, window.innerHeight - MENU_HEIGHT)
		}
	},
	mounted() {
		document.addEventListener('click', this.onOutsideInteraction, true)
		document.addEventListener('keydown', this.onKeydown, true)
		window.addEventListener('scroll', this.onOutsideInteraction, true)
		window.addEventListener('resize', this.onOutsideInteraction)

		if (this.$refs.item) {
			this.$refs.item.focus()
		}
	},
	beforeDestroy() {
		document.removeEventListener('click', this.onOutsideInteraction, true)
		document.removeEventListener('keydown', this.onKeydown, true)
		window.removeEventListener('scroll', this.onOutsideInteraction, true)
		window.removeEventListener('resize', this.onOutsideInteraction)
	},
	methods: {
		clamp(value, max) {
			return Math.max(VIEWPORT_MARGIN, Math.min(value, max))
		},
		onKeydown(event) {
			if (event.key === 'Escape') {
				this.$emit('close')
			}
		},
		onOutsideInteraction(event) {
			const target = event.target
			// A window resize targets the window. Node.contains throws unless
			// its argument is a Node, which would leave the menu open.
			if (target instanceof Node && this.$el.contains(target)) {
				return
			}
			this.$emit('close')
		}
	}
}
</script>
